import React from "react";
import styles from "./NotificationDetailModal.module.css";
import { Portal } from "../../Portal/Portal";
import { Notification } from "../../../types/notifications";

interface NotificationDetailModalProps {
  notification: Notification;
  onClose: () => void;
}

export const NotificationDetailModal: React.FC<NotificationDetailModalProps> = ({
  notification,
  onClose,
}) => {

  return (
    <Portal>
      <div className={styles.overlay} onClick={onClose}>
        <div
          className={styles.container}
          onClick={(e) => e.stopPropagation()}
        >
          <button className={styles.closeButton} onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </button>

          {notification.image_url && (
            <div className={styles.imageContainer}>
              <img
                src={notification.image_url}
                alt={notification.title}
                className={styles.image}
              />
            </div>
          )}

          <div className={styles.content}>
            <div className={styles.textContent}>
              <h2 className={styles.title}>{notification.title}</h2>
              <p className={styles.message}>{notification.message}</p>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};
